"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.__REDWOOD__ = void 0;
// These values are replaced by the webpack define plugin
var __REDWOOD__ = {
  API_PROXY_PATH: __REDWOOD__API_PROXY_PATH
};
exports.__REDWOOD__ = __REDWOOD__;